import { render, staticRenderFns } from "./SideBarDownload.vue?vue&type=template&id=53d4812d&scoped=true"
import script from "./SideBarDownload.vue?vue&type=script&lang=js"
export * from "./SideBarDownload.vue?vue&type=script&lang=js"
import style0 from "./SideBarDownload.vue?vue&type=style&index=0&id=53d4812d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d4812d",
  null
  
)

export default component.exports